<script>
import {SpeakerMixin} from "../lib/speaker-utils.js"
import PersonThumb from "../lib/person-thumb.vue"

export default {
  mixins: [SpeakerMixin],
  components: {PersonThumb},
  props: {
    speaker: {type: Object, required: true},
    isModerator: {type: Boolean, default: false},
  },

  computed: {
    speakerLink() {
      return this.speakerUrl(this.speaker)
    }
  },

  methods: {
    onSpeakerClick() {
      this.$emit('speaker-click', this.speaker)
    }
  }
}
</script>

<template>
  <a href="" @click.prevent="onSpeakerClick">
    <person-thumb
      :name="speakerFullName(speaker)"
      :image-url="speaker.profile_img_url"
      :job-title="speaker.job_title || ''"
      :company="speaker.company || ''"
      :subtitle="isModerator ? 'Moderator:in' : ''"
    />
  </a>
</template>

<style scoped>
a { text-decoration: none; }
</style>
